<script>
  export let text = "define Text";
  export let disable = false;
  export let fullDisable = false;
  export let value = null;
  export let increment = (i) => {
    return Math.round(i * 1.2);
  };
  export let decrement = (i) => {
    return Math.round(i / 1.2);
  };
  export let unit = "";
  export let defaultvalue = 100;
  export let reset = () => {
    value = defaultvalue;
  };
  export let isEditable = false;
  export let showValue = true;
  export let minValue = null;
  export let maxValue = null;
  let isEditing = false;

  function handleMinus() {
    if (!fullDisable && (minValue === null || value > minValue)) value = decrement(value);
  }

  function handlePlus() {
    if (!fullDisable && (maxValue === null || value < maxValue)) value = increment(value);
  }

  function handleDoubleClick() {
    if (!fullDisable) isEditing = true;
  }

  function handleBlur(event) {
    value = event.target.value;
    isEditing = false;
  }
</script>

<div class="button_wrapper" class:full-disable={fullDisable === true}>
  <div
    on:click={handleMinus}
    on:keypress={handleMinus}
    class="left button"
    class:disable={disable === true || (minValue !== null && value <= minValue)}
  >
    <img src="/img/assistant/icons/minus.svg" alt="less" />
  </div>
  <div class="center" class:full-disable={fullDisable === true}>
    <div class="text">{text}</div>
    <div
      class="value bold"
      class:disable={fullDisable === true}
      on:click={reset}
      on:keypress={reset}
      on:dblclick={handleDoubleClick}
    >
      {#if isEditing && isEditable}
        <input
          type="number"
          class="no-steppers"
          bind:value
          on:blur={handleBlur}
        />
      {:else if showValue}
        {#if value !== null}
          {value}
        {/if}
        {#if unit !== ""}
          {unit}
        {/if}
      {/if}
    </div>
  </div>
  <div
    on:click={handlePlus}
    on:keypress={handlePlus}
    class="right button"
    class:disable={fullDisable === true || (maxValue !== null && value >= maxValue)}
  >
    <img src="/img/assistant/icons/plus.svg" alt="more" />
  </div>
</div>

<style>
  .button_wrapper {
    display: flex;
    gap: 0.5rem;
    background-color: var(--pax-black);
    height: 3rem;
    align-items: center;
    border-radius: 0.5rem;
    padding: 0 0.25rem;
    color: var(--pax-white);
  }

  .center {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    transition: 300ms ease-in-out;
    height: 2.4rem;
    width: 2.4rem;
    cursor: pointer;
  }

  .value {
    cursor: pointer;
  }

  .button:hover {
    background-color: #2a2a2f;
  }

  .disable {
    cursor: not-allowed;
  }

  .full-disable, .full-disable:hover, .full-disable .disable, .full-disable .disable:hover, .disable:hover, .disable:hover{
    cursor: not-allowed;
    background-color: var(--pax-black);
  }

  .no-steppers {
    background-color: black;
    border: none;
    max-width: 2.4rem;
  }

  .no-steppers::-webkit-outer-spin-button,
  .no-steppers::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
